import styled from 'styled-components'

import { theme } from 'styles/theme'

const { space, colors, media } = theme

export const Wrapper = styled.header`
  width: 100%;
  padding-top: ${space['spacing-sm']};
  padding-bottom: ${space['spacing-sm']};

  @media (${media.tablet}) {
    position: relative;
    z-index: 1;
    background-color: ${colors['neutral-background-default']};
  }
`
export const LogoWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${space['spacing-sm']};
  width: 100%;
`
